import React from "react";
import ReactDOM from "react-dom";
import { Language, SporProvider } from "@vygruppen/spor-react";
import { BrowserRouter as Router } from "react-router-dom";
import "index.css";
import App from "App";
import * as serviceWorkerRegistration from "serviceWorkerRegistration";

ReactDOM.render(
    <React.StrictMode>
        <SporProvider language={Language.NorwegianBokmal}>
            <Router>
                <App />
            </Router>
        </SporProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// Registers serviceWorker to enable offline usage.
// Possible to unregister by switching to .unregister()
serviceWorkerRegistration.register();
